import { Box } from '@mantine/core'
import { useClickOutside, useMediaQuery } from '@mantine/hooks'
import { useContext, useEffect, useState } from 'react'

import { LightSearchContext } from '@/contexts/LightSearchContext'

import SearchHitList from '@/components/molecules/SearchHitList'
import { AnimatePresence, motion } from 'motion/react'
import { DesktopSearchBox, MobileSearchBox } from './SearchBar.components'
import { IsMobile } from '@/utils/mobile'

const SearchBar = () => {
    return <SearchBarView />
}

const SearchBarView = () => {
    const ctx = useContext(LightSearchContext)
    const ref = useClickOutside<HTMLDivElement>(() => {
        ctx.onClickOutside()
    })

    const isMobile = IsMobile();

    const {
        searchQuery,
        onSearchChange,
        onClearSearch,
        onFocusSearchBox,
        onSearchSubmit,
        isSearchBarOpen,
    } = useContext(LightSearchContext)

     
    return (
        <Box
            ref={ref}
            data-testid="search-bar"
            className="relative items-center w-full group gap-x-2"
        >
            {!isMobile && (
                <DesktopSearchBox
                    onChange={onSearchChange}
                    onClear={onClearSearch}
                    onFocus={onFocusSearchBox}
                    onSearch={onSearchSubmit}
                    value={searchQuery}
                />
            )}

            {isMobile && (
                <MobileSearchBox
                    onChange={onSearchChange}
                    onClear={onClearSearch}
                    onFocus={onFocusSearchBox}
                    onSearch={onSearchSubmit}
                    value={searchQuery}
                />
            )}
            <AnimatePresence mode="wait">
                {isSearchBarOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2, ease: 'easeOut' }}
                    >
                        <SearchHitList />
                    </motion.div>
                )}
            </AnimatePresence>
        </Box>
    )
}

export default SearchBar
